import * as types from "../types";

export const addEnquiryRequest = ({ requestData }) => ({
  type: types.ADD_ENQUIRY_REQUEST,
  payload: {
    requestData,
  },
});

export const addEnquirySuccess = ({ res }) => ({
  type: types.ADD_ENQUIRY_SUCCESS,
  payload: {
    res,
  },
});

export const addEnquiryFailure = ({ error }) => ({
  type: types.ADD_ENQUIRY_FAILURE,
  payload: {
    error: error.message,
  },
});

export const resetAddEnquiryForm = () => ({
  type: types.RESET_ADD_ENQUIRY_FORM,
});
